<div class="table-title">
    <ng-container>
        <span class="sectionTitle" stylePreference [textColor]="textColor">
            {{ sectionTitle }}
        </span>
    </ng-container>
    <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
</div>
<ng-container *ngFor="let sectionTable of sectionData; let i = index">
    <table style="width: 100%">
        <ng-container *ngFor="let row of sectionTable">
            <ng-container *ngIf="row.rowType === 'TableHead'">
                <thead>
                    <tr
                        [style.color]="tableHeaderColor"
                        class="big-row-min-height_plus-border-height black-border-down header"
                    >
                        <th class="title text-align-bottom">{{ row.t }}</th>
                        <th class="notes text-align-bottom" *ngIf="showNotes">{{ row.r }}</th>
                        <th class="value text-align-bottom" [style.background-color]="i === 0 ? backgroundColor : ''">
                            {{ row.cV }}
                        </th>
                        <th class="value text-align-bottom" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY">{{ row.pV }}</th>
                    </tr>
                </thead>
            </ng-container>

            <ng-container *ngIf="row.rowType === 'Row' || row.rowType === 'SubRow'">
                <tr [style.color]="textColor" class="row-min-height_plus-border-height gray-border-down">
                    <td class="title text-align-top">
                        <div class="text-cell">
                            <span [ngClass]="row.rowType === 'SubRow' ? 'name-padding-left' : ''"></span
                            ><span>{{ row.t }}</span>
                        </div>
                    </td>
                    <td class="notes text-align-top" *ngIf="showNotes">{{ row.r }}</td>
                    <td class="value text-align-top" [style.background-color]="backgroundColor">{{ row.cV }}</td>
                    <td class="value text-align-top" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY">{{ row.pV }}</td>
                </tr>
            </ng-container>
            <ng-container *ngIf="row.rowType === 'GroupTotal' || row.rowType === 'TableTotal'">
                <tr
                    [style.color]="tableFooterColor"
                    [ngClass]="'reset-counter-' + (row.level == undefined ? 1 : row.level)"
                    class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                >
                    <td class="title row-min-height black-border-down bolder-bigger big-row-min-height text-align-top">
                        <span> {{ row.t }}</span>
                    </td>
                    <td
                        class="notes black-border-down bolder-bigger big-row-min-height text-align-top"
                        *ngIf="showNotes"
                    >
                        {{ row.r }}
                    </td>
                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                        [style.background-color]="backgroundColor"
                    >
                        {{ row.cV }}
                    </td>

                    <td
                        class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                        *ngIf="!noPreviousData"
                        [style.background-color]="backgroundColorPY"
                    >
                        {{ row.pV }}
                    </td>
                </tr>
            </ng-container>
        </ng-container>
    </table>
    <br />
</ng-container>
